import { PaperVouchersRemittanceForm } from './RemittancesDeliverySlipModal.types';

export const DeliverySlipModalFieldNames = {
  RELATIVE_ID: 'relativeId' as keyof PaperVouchersRemittanceForm,
  COMMUNICATION: 'communication' as keyof PaperVouchersRemittanceForm,
  NUMBER_OF_VOUCHERS: 'numberOfVouchers' as keyof PaperVouchersRemittanceForm,
  EFFECTIVE_MONTH_AND_YEAR: 'effectiveMonthAndYears' as keyof PaperVouchersRemittanceForm,
};
